<div class="page-container">
	<div class="section lead-status-filter">
		<h5 class="text-primary">Lead Status</h5>
		<app-dropdown-control
			[formGroup]="form"
			name="leadStatus"
			placeholder="Filter by status"
			[options]="leadStatusOptions"
			[multiple]="true"
			[clearable]="true"
		/>
		<div class="table-actions">
			<app-radio-group-control class="action-item" [formGroup]="form" name="leadRequestType" [options]="leadRequestTypeOptions" />
			<div class="action-item right">
				<app-search-control [control]="searchControl" placeholder="Search"></app-search-control>
				<button type="button" class="btn btn-sm btn-primary" [routerLink]="ClientLeadsRoutes.CREATE">
					<i class="bi bi-plus"> </i>
					Add new
				</button>
			</div>
		</div>
	</div>

	<div class="content">
		<div class="section table-container">
			<div class="table-headings">
				<div class="column-name long">Client Name</div>
				<div class="column-name long">Property Address</div>
				<div class="column-name long">Assessment Type</div>
				<div class="column-name long">Submitted Date</div>
				<div class="column-name long">Preferred Date</div>
				<div class="column-name short">Status</div>
			</div>

			<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent"></app-loading-state>
			<ng-template #loadedContent>
				<ng-container *ngIf="leads.length === 0; else leadsTable">
					<div class="table-row">
						<div class="inner-row">
							<em class="fw-bold">
								No
								{{ leadStatus.value.join(', ') | titlecase }}
								leads.
							</em>
						</div>
					</div>
				</ng-container>
				<ng-template #leadsTable>
					<ng-container *ngFor="let lead of leads">
						<div
							class="table-row cursor-p"
							(click)="onLeadItemClick(lead)"
							(keyup.enter)="onLeadItemClick(lead)"
							tabindex="0"
							role="button"
						>
							<div class="inner-row long">{{ lead.personalDetails.name | nullDefault: 'N/A' }}</div>
							<div class="inner-row long">
								{{ lead?.personalDetails?.installationAddress?.fullAddress | nullDefault: '-' }}
							</div>
							<div class="inner-row long">
								{{ lead?.onSiteVisitAssessment?.serviceType | nullDefault: '-' }}
							</div>
							<div class="inner-row long">{{ lead?.createdDate?.toDate() | date: 'yyyy-MM-dd' }}</div>
							<div class="inner-row long">
								<ng-container [ngSwitch]="lead.requestType">
									<ng-container *ngSwitchCase="LeadRequestType.ON_SITE_VISIT">
										<ng-container [ngSwitch]="lead.onSiteVisitAssessment?.dateTime?.type">
											<ng-container *ngSwitchCase="LeadRequestDatetimeType.REQUEST">
												{{
													lead?.onSiteVisitAssessment?.dateTime?.requestedDate
														| ngbDateToDate
														| date: 'yyyy-MM-dd'
														| nullDefault: '-'
												}}</ng-container
											>
											<ng-container *ngSwitchCase="LeadRequestDatetimeType.ASAP">ASAP</ng-container>
											<ng-container *ngSwitchDefault> - </ng-container>
										</ng-container>
									</ng-container>
									<ng-container *ngSwitchCase="LeadRequestType.CALL"> - </ng-container>
									<ng-container *ngSwitchDefault> - </ng-container>
								</ng-container>
							</div>
							<div class="inner-row short">
								<app-lead-status-badge [status]="lead.status"></app-lead-status-badge>
							</div>
						</div>
					</ng-container>
				</ng-template>
			</ng-template>
		</div>
	</div>
</div>
